import { forwardRef } from 'react';

import {
  disabledClasses,
  hasParentFocusIndicatorClasses,
  hoverClasses,
  inputAfterClasses,
  inputClasses,
  inputSizeClasses,
  labelClasses,
  labelDisabledClasses,
  wrapperClasses,
  wrapperHadLabelClasses
} from './Radio.classes';
import type { RadioProps } from './Radio.types';

import { cn } from 'helpers/classnames';

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props: RadioProps, ref) => {
  const { className, hasParentFocusIndicator, label, children, size = 'default', ...forwardProps } = props;
  const { disabled, name, value } = props;

  const RADIO_ID = `radio-${name}-${value}`;

  const inputProps = {
    ...forwardProps,
    className: cn(
      inputClasses,
      inputSizeClasses[size],
      inputAfterClasses,
      disabled ? disabledClasses : hoverClasses,
      (label || hasParentFocusIndicator) && hasParentFocusIndicatorClasses
    ),
    id: RADIO_ID,
    ref,
    type: 'radio'
  };

  if (label) {
    return (
      <div className={cn(wrapperClasses, wrapperHadLabelClasses, className)}>
        <input {...inputProps} />
        <label className={cn(labelClasses, disabled && labelDisabledClasses)} htmlFor={RADIO_ID}>
          <span>{label}</span>
          {children}
        </label>
      </div>
    );
  }

  return <input {...inputProps} />;
});

Radio.displayName = 'Radio';
